import { View } from '@/components'
import * as React from 'react'
import styled from 'styled-components'
import { ProtectCenterPage } from '@/modules/landings/protection/ProtectCenterPage'

const ProtectionReportPageWrapper = styled(View)``

const ProtectionrNumber = () => {
	return (
		<ProtectionReportPageWrapper>
			<ProtectCenterPage />
		</ProtectionReportPageWrapper>
	)
}

export default ProtectionrNumber
